import { render, staticRenderFns } from "./CarbodiesProductEdit.vue?vue&type=template&id=7425269e"
import script from "./CarbodiesProductEdit.vue?vue&type=script&lang=js"
export * from "./CarbodiesProductEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports